import { BotField } from './types';

export function getAllBotFields(): BotField[] {
  return Object.values(BotField);
}
